export const GridColumnType = {
    Text: 1,
    LINK:2,
    CHECKBOX:3,
    TOGGLE:4,
    LABEL:5,
    DATE:6,
    MONEY:7,
    // add other types
    ACTION:14,
    CUSTOM:15
}
